module.exports = __webpack_public_path__ + "static/media/Group 1251.4987dd91.svg";